export default __webpack_public_path__ + "static/media/comment.3031aac9.svg";